import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

function ProjectRoute() {
  const token = localStorage.getItem("access");
  const location = useLocation();

  // 개발모드 StrictMode에서 중복 alert 방지
  const alertedRef = useRef(false);

  useEffect(() => {
    if (!token && !alertedRef.current) {
      alertedRef.current = true;
      // 로그인 후 돌아올 경로 저장
      localStorage.setItem("redirectTo", location.pathname);
      alert("접근 권한이 없습니다. 로그인 해주세요.");
    }
  }, [token, location.pathname]);

  if (!token) {
    // replace로 히스토리 정리
    return <Navigate to="/login" replace />;
  }

  // const allowedRoles = ["admin", "projectmanager", "projectworker"];
  // if (!allowedRoles.includes(role)) {
  //   return <Navigate to="/login" />;
  // }

  return <Outlet />;
}

export default ProjectRoute;


// 인증, 권한 임시 무효처리
// import { Outlet } from "react-router-dom";

// function ProjectRoute() {
//   return <Outlet />;
// }

// export default ProjectRoute;
